import type {MapTransform} from "@/encounter/model/ViewPort.ts";
import type Position from "@/util/Position.ts";

export const MIN_MAP_SCALE = 0.05;
export const MAX_MAP_SCALE = 8;

export function zoomMapTransform(transform: MapTransform, pointer: Position, zoomIn: boolean): MapTransform {
    const scale = transform.scale;
    if (!(scale > 0) || !Number.isFinite(scale)) return transform;
    const nextScale = Math.min(MAX_MAP_SCALE, Math.max(MIN_MAP_SCALE, scale * (zoomIn ? 1.05 : 1 / 1.05)));
    if (nextScale === scale) return transform;
    const worldX = (pointer.x - transform.x) / scale;
    const worldY = (pointer.y - transform.y) / scale;
    return {
        x: pointer.x - worldX * nextScale,
        y: pointer.y - worldY * nextScale,
        scale: nextScale,
    };
}
